export default {
  chartType: "worldmap",
  showTitle: true,
  showControls: true,
  showQuery: true,
  showColor: true,
  showSortZ: true,
  showSortX: false,
  showSortY: false,
  showNormalize: false,
  showRecency: true,
  showSize: true,
  showMetric: false,
  showMetricX: false,
  showMetricY: false,
  showTypeCats: false
};
